import styled from 'styled-components';

export const StyledMouseHint = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-family: "BebasNeue";
  font-size: 1.5rem;
  font-weight: 400;
  color: white;
  line-height: 0.75;
  text-transform: uppercase;
  text-align: end;
  gap: 24px;
  padding: 8px 16px;
  transition: opacity linear .2s;
  opacity: ${({ $visible }) => $visible ? '1.0' : '0.0'};
  background: ${({ theme }) => theme.backgroundMenu};
  border-bottom: solid ${({ theme}) => theme.frameWidth} white;

  .mouse-hint-section {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }

  .mouse-hint-text {
    padding-top: 4px;
    opacity: 1.0;
    span {
      opacity: 0.6;
    }
  }

  .mouse-hint-img {
    height: ${({ theme }) => theme.iconSize};
    width: ${({ theme }) => theme.iconSize};
  }
`;

